import React from "react";
import PropTypes from "prop-types";

import { FaCcMastercard, FaCcVisa, FaPaypal, FaWallet } from "react-icons/fa";
import { SiGooglepay } from "react-icons/si";
import { RiBankFill } from "react-icons/ri";
import { BiRadioCircle, BiRadioCircleMarked } from "react-icons/bi";
import RupaySVG from "../../../../../assets/images/nl-images/rupay.svg";

import "./payment-methods.m.css";

const PaymentMethods = ({ paymentOption, setPaymentOption }) => {
  return (
    <div styleName="section-wrapper">
      <h3 styleName="title">Choose your payment method:</h3>
      <div styleName="payment-methods-wrapper">
        <div
          styleName={`payment-method ${
            paymentOption === "card" ? "selected" : ""
          }`}
          onClick={() => setPaymentOption("card")}
        >
          <div styleName="checkbox-svg">
            {paymentOption === "card" ? (
              <BiRadioCircleMarked styleName="checkbox-svg" />
            ) : (
              <BiRadioCircle styleName="checkbox-svg" />
            )}
          </div>
          <div styleName="payment-div-block">
            <span styleName="payment-title">Credit or Debit Card</span>
            {/* </div>
          <div styleName="payment-div-block"> */}
            <FaCcVisa />
            <FaCcMastercard />
          </div>
        </div>
        <div
          styleName={`payment-method ${
            paymentOption === "upi" ? "selected" : ""
          }`}
          onClick={() => setPaymentOption("upi")}
        >
          <div styleName="checkbox-svg">
            {paymentOption === "card" ? (
              <BiRadioCircle />
            ) : (
              <BiRadioCircleMarked />
            )}
          </div>
          <div styleName="payment-div-block">
            <span styleName="payment-title">
              UPI, Netbanking, Rupay, Wallets or Paypal
            </span>
            {/* </div>
          <div styleName="payment-div-block"> */}
            <SiGooglepay />
            <RiBankFill />
            <img
              src={RupaySVG}
              alt="rupay svg"
              style={{
                height: "1.5rem",
                width: "1.5rem",
                color: "#333"
              }}
            />
            <FaWallet />
            <FaPaypal />
          </div>
        </div>
      </div>
    </div>
  );
};

PaymentMethods.propTypes = {
  paymentOption: PropTypes.string,
  setPaymentOption: PropTypes.func
};

export { PaymentMethods };
